/**
 * Whether completing a call should ask to impound the vehicle.
 *
 * Only for a call marked as an impound, and only for a role that may create
 * one: without impounds.create the backend refuses the impound, and the old
 * flow asked anyway, failed, and completed the call with an error toast. A
 * driver without the key completes the call the plain way instead.
 */
export const completesIntoImpound = (
  isImpound: boolean | undefined,
  canCreateImpounds: boolean
): boolean => !!isImpound && canCreateImpounds;
